import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatIDR } from '../lib/format';
import TransactionForm from '../components/TransactionForm';
import { PaymentListEditor } from '../components/PaymentListEditor';

export default function EditTransaction() {
  const { id } = useParams();
  const [tx, setTx] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    api
      .get(`/transactions/${id}`)
      .then((r) => {
        if (r.data.status === 'cancelled') {
          setError('Order yang dibatalkan tidak bisa diedit.');
        } else {
          setTx(r.data);
        }
      })
      .catch(() => setError('Order tidak ditemukan.'));
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) {
    return (
      <div className="py-20 text-center" data-testid="edit-transaction-error">
        <p className="text-sm text-danger font-semibold">{error}</p>
      </div>
    );
  }
  if (!tx) return <p className="text-sm text-mocha py-16 text-center">Memuat order…</p>;

  return (
    <div className="space-y-5" data-testid="edit-transaction-page">
      <div>
        <h1 className="font-display text-3xl text-ink tracking-tight">Edit Order {tx.transaction_number}</h1>
        <p className="text-sm text-mocha mt-1">Tambah atau kurangi barang, ubah tanggal — stok dicek ulang otomatis.</p>
      </div>
      <TransactionForm initial={tx} txId={id} />
      {tx.payments?.length > 0 && (
        <div className="bg-white rounded-2xl border border-border shadow-soft p-5" data-testid="edit-order-payments">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-display text-xl text-ink">Pembayaran Tercatat</h2>
            <p className="text-xs text-mocha">Klik ikon pensil untuk koreksi metode/nominal/tanggal.</p>
          </div>
          <PaymentListEditor payments={tx.payments} onChanged={load} />
          <p className="text-xs text-mocha mt-3">
            Terbayar <b className="text-brown">{formatIDR(tx.paid)}</b> • Sisa <b className={tx.remaining > 0 ? 'text-danger' : 'text-success'}>{formatIDR(tx.remaining)}</b>
          </p>
        </div>
      )}
      {tx.paid > 0 && (
        <p className="hidden" data-testid="edit-paid-marker">{tx.paid}</p>
      )}
    </div>
  );
}

void toast;
